import React from "react"
import PropTypes from "prop-types"

import "./subtitle.scss"

const Subtitle = ({ children }) => (
  <p styleName="subtitle" dangerouslySetInnerHTML={{ __html: children }}></p>
)

Subtitle.propTypes = {
  children: PropTypes.node,
}

export default Subtitle
